$(document).ready(function($) {

    // Если список больше 7 пунктов формируем из одного списка два
    // и выдаём на страницу
    $('[data-list-exhibition-detail]').each(function(){
        let listExhibition = $(this),
            listUl = listExhibition.children('ul'),
            childrenListExhibition = listExhibition.children();

        if(listUl.length == 1) {
            let currFirstList = listUl.find('li:lt(7)'),
                currSecondList = listUl.find('li:gt(6)');

            if(currSecondList.length) {
                listExhibition.empty();
                listUl.empty();

                childrenListExhibition.each(function(index, element){
                    var _this = $(this);

                    if($(this).is('ul')) {
                        listUl.append(currFirstList);
                        listExhibition.append(listUl);

                        listExhibition.append('<ul class="hidden-mobile" data-hidden-mobile-list-exhibition-detail="true" style="display: none;"></ul>');
                        listExhibition.find('[data-hidden-mobile-list-exhibition-detail]').append(currSecondList);
                    }else{
                        listExhibition.append(_this);
                    }
                });
            }
        }

        if( listUl.length > 1){
            var isFirstUl = true;
            listExhibition.empty();

            childrenListExhibition.each(function(index, element){
                var _this = $(this);

                if(isFirstUl) {
                    listExhibition.append(_this);

                    if($(this).is('ul')) {
                        listExhibition.append('<div class="hidden-mobile" data-hidden-mobile-list-exhibition-detail="true" style="display: none;"></div>');
                        isFirstUl = false;
                    }
                }else{
                    listExhibition.find('[data-hidden-mobile-list-exhibition-detail]').append(_this);
                }
            });
        }
    });

    $('[data-btn-list-exhibition-detail]').on('click', function(){
        let _this = $(this),
            btnWrap = _this.closest('[data-wrap-btn-list-exhibition-detail]'),
            container = _this.closest('[data-wrap-list-exhibition-detail]'),
            hiddenList = container.find('[data-hidden-mobile-list-exhibition-detail]');

        btnWrap.toggleClass('open');
        hiddenList.slideToggle();
    });
    
});


// WEBPACK FOOTER //
// ./components/exhibition.js